'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowLeftFromLine, iconArrowLeftFromLineTag } from '@ni/nimble-components/dist/esm/icons/arrow-left-from-line';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowLeftFromLine };
export { iconArrowLeftFromLineTag };
export const NimbleIconArrowLeftFromLine = wrap(IconArrowLeftFromLine);